import { render, staticRenderFns } from "./copy.vue?vue&type=template&id=4377929f"
import script from "./copy.vue?vue&type=script&setup=true&lang=js"
export * from "./copy.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports